<template>
    <div class="main-page">
        <!--<vue-ins-progress-bar></vue-ins-progress-bar>-->
        <Header v-if="!appOptions.appWithoutHeader"/>
        <Sidebar v-if="!appOptions.appWithoutSidebar"/>
        <tabs v-if="!appOptions.appTabs"></tabs>
        <Footer v-if="appOptions.appWithFooter"/>
    </div>
</template>

<script>
    import AppOptions from '../config/AppOptions.vue'
    import Sidebar from '../components/Sidebar.vue'
    import Header from '../components/Header.vue'
    import Footer from '../components/Footer.vue'
    import Tabs from '../pages/standard/Tabs.vue'
    export default {
        name: 'Main',
        data() {
            return {
                appOptions: AppOptions
            }
        },
        components: {
            Sidebar,
            Header,
            Footer,
            Tabs
        },
        created() {
            //this.$insProgress.start();
            this.$router.beforeEach((to, from, next) => {
                //this.$insProgress.start();
                if (this.appOptions.appSidebarMobileToggled === true) {
                    this.appOptions.appSidebarMobileClosed = true;
                    setTimeout(() => {
                        this.appOptions.appSidebarMobileClosed = false;
                        this.appOptions.appSidebarMobileToggled = false;
                    }, 250);
                }
                next()
            });
            // this.$router.afterEach(() => {
            //     this.$insProgress.finish()
            // })
        }
    }
</script>
<style lang="scss">

</style>
